import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

export const STRATEGIES_QUERY_KEY = ["strategies"] as const;

export type ListStrategiesQuery = {
  include_deleted?: boolean;
};

export function useStrategies(params: ListStrategiesQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...STRATEGIES_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/strategies", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list strategies");
      }
      return data;
    },
  });
}
